<template lang="pug">
  .container(ref='container')
    Header
    Editor.editor
</template>

<script>
import Editor from '@/components/Editor'
import Header from '@/components/Header'

export default {
  name: 'Home',
  components: {
    Header,
    Editor
  },
  mounted() {
    this.$refs.container.scrollIntoView()
  }
}
</script>

<style scoped>
.container {
  padding: 32px 8px 0;
  margin: 0 auto 50vh;
  max-width: 960px;
}

.editor {
  margin-top: 60vh;
}

</style>
